<script setup lang="ts">
const icon = `${window.location.origin}/favicon.svg`;
</script>

<template>
  <img width="48" height="48" alt="PRO-landkort" :src="icon" />
</template>
